<template>
  <div class="partner-container">
    <div class="topimage">
      <el-image style="width:100%" :src="require('@/assets/guanyu/partner_banner.png')"></el-image>
    </div>
    <div class="appmain">
      <div class="title">
        {{ $t('partner.title') }}
      </div>

      <div class="expect">
        {{ $t('partner.expect') }}
      </div>

      <div class="title">
        {{ $t('partner.benefits') }}
      </div>

      <div class="benefits-wrapper">
        <div class="benefits-item" v-for="item in benefitsList" :key="item.idx">
          <div class="item-title-wrap">
            <span class="item-idx">{{ item.idx }}</span>
            <span class="item-title">{{ item.title }}</span>
          </div>
          <div class="item-desc">{{ item.desc }}</div>
        </div>
      </div>

      <div class="title">
        {{ $t('partner.becomePartner') }}
      </div>

      <div v-if="$i18n.locale == 'tr'" class="form-wrap">
        <iframe id="okki-form-98516885254989" width="100%" height="100%"
          src="https://tfile.xiaoman.cn/okki-form/index.html#/?client_id=484497&site_id=31916&form_id=98516885254989"
          frameborder="0"></iframe>
      </div>
      <div v-else class="form-wrap">
        <iframe id="okki-form-69506079073944" width="100%" height="100%"
          src="https://tfile.xiaoman.cn/okki-form/index.html#/?client_id=484497&site_id=24585&form_id=69506079073944"
          frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        hrParams: {
          page: 1,
          limit: 10
        },
        list: [],
        dialogVisible: false,
        html: '',
        pagehtml: '',
        title: ''
      }
    },
    computed: {
      benefitsList() {
        const _list = []
        for (let i = 1; i < 7; i++) {
          _list.push({
            idx: '0' + i,
            title: this.$t(`partner.benefits${i}`),
            desc: this.$t(`partner.benefitsText${i}`)
          })
        }
        return _list
      }
    },
    metaInfo() {
      return {
        title: this.title,
        meta: [
          {
            name: 'keyWords',
            content: this.$t('seo.keywords')
          },
          {
            name: 'description',
            content: this.$t('seo.description')
          }
        ]
      }
    },
    created() {
      this.title = this.$t('layout.partner') + '-' + this.$t('seo.title')

    },
    methods: {


    }
  }
</script>
<style lang="scss" scoped>
  .partner-container {
    color: #333333;
    font-size: 16px;
    font-style: normal;
    font-family: SourceHanSansCN, SourceHanSansCN;

    background: #ffffff;
    padding-bottom: 20px;

    .title {
      padding: 30px;
      font-weight: bold;
      font-size: 24px;
      line-height: 36px;
      text-align: center;
    }

    .expect {
      line-height: 38px;
      margin-bottom: 60px;
    }

    .benefits-wrapper {
      padding: 40px 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 26px;
    }

    @media screen and (max-width: 767px) {
      .benefits-wrapper {
        grid-template-columns: 1fr;
      }
    }

    .benefits-item {
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      width: 100%;
      min-height: 100px;
      padding: 30px 40px;

      overflow: hidden;
      position: relative;

      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;

        height: 4px;
        background: #0052D9;
      }


      .item-title-wrap {
        margin-bottom: 10px;

        .item-idx {
          font-family: OPPOSans, OPPOSans;
          font-weight: normal;
          font-size: 26px;
          color: #0052D9;
          line-height: 36px;
          margin-right: 15px;
        }

        .item-title {
          font-weight: bold;
          font-size: 24px;
          color: #000000;
          line-height: 36px;
        }
      }

      .item-desc {
        font-weight: 400;
        line-height: 32px;
      }
    }

    .form-wrap {
      width: 100%;
      height: 580px;
    }

  }
</style>
